import React from 'react'
import './timeline.css'
export default function Timeline() {
    return (
        <div class="timeline">
            <div class="container left">
                <div class="content">
                    <h2>2025</h2>
                    <p>Freelancing / QA Consultation </p>
                </div>
            </div>
           
            <div class="container right">
                <div class="content">
                    <h2>2023 - 2024</h2>
                    <p>Completed Masters in Data Science and Analytics </p>
                </div>
            </div>

            <div class="container left">
                <div class="content">
                    <h2>2023</h2>
                    <p>Senior Software Quality Analyst</p>
                </div>
            </div>

             <div class="container right">
                <div class="content">
                    <h2>2021 - 2023</h2>
                    <p>Senior Software Quality Analyst</p>
                </div>
            </div>

            <div class="container left">
                <div class="content">
                    <h2>2020 - 2021</h2>
                    <p>Software Quality Analyst</p>
                </div>
            </div>
            <div class="container right">
                <div class="content">
                    <h2>2020 - 2023</h2>
                    <p>Software Quality Assurance Engineer</p>
                </div>
            </div>
            
            <div class="container left">
                <div class="content">
                    <h2>2018 - 2019</h2>
                    <p>Associate Quality Assurance Engineer</p>
                </div>
            </div>
            <div class="container right">
                <div class="content">
                    <h2>2017</h2>
                    <p>Completed BE in Computer Engineering</p>
                </div>
            </div>
        </div>
    )
}
